import React, { useEffect } from "react";
import HeroSection from "./HeroSection/HeroSection";
import Main from "./Business/Main";
import OurServices from "./OurServices/OurServices";
import WhyUs from "./WhyUs/WhyUs";
import Testimonials from "./Testimonials/Testimonials";
import Questions from "./Questions/Questions";
import { useLocation, useNavigate } from "react-router-dom";

const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const section = document.getElementById(location.state.scrollTo);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
        navigate(location.pathname, { replace: true });
      }
    }
  }, [location.state, navigate]);

  return (
    <div className="bg-gray-300">
      <HeroSection />
      <Main />
      <OurServices id="services" />
      <WhyUs />
      <Testimonials />
      <Questions />
    </div>
  );
};

export default Home;
